import { useEffect, useState } from 'react';
import { BACKEND_URL, resolveUrl, thumbUrl } from './api';

const KEY = 'dealrun_recent';
const MAX_RECENT = 10;

export const getRecent = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (_) { return []; }
};

export const saveRecent = (deal, brand) => {
  const list = getRecent().filter((r) => r.deal.id !== deal.id);
  list.unshift({ deal, brand: brand ? { ...brand, catalogs: undefined } : null, savedAt: new Date().toISOString() });
  localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX_RECENT)));
};

export const findRecent = (id) => getRecent().find((r) => r.deal.id === id) || null;

export const registerServiceWorker = () => {
  if (!('serviceWorker' in navigator)) return;
  // A new service worker took over after an update: reload once so the fresh bundle is used right away.
  let hadController = !!navigator.serviceWorker.controller;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (hadController && !sessionStorage.getItem('dealgo_sw_reloaded')) { sessionStorage.setItem('dealgo_sw_reloaded', '1'); window.location.reload(); }
    hadController = true;
  });
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(() => navigator.serviceWorker.ready).then((reg) => {
      const same = (u) => u && u.startsWith(window.location.origin);
      const urls = ['/', ...[...document.scripts].map((s) => s.src), ...[...document.styleSheets].map((s) => s.href)].filter((u) => u === '/' || same(u));
      (reg.active || navigator.serviceWorker.controller)?.postMessage({ type: 'CACHE_URLS', urls, key: 'shell', cache: 'shell' });
    }).catch(() => {});
  });
};

export const offlineUrlsFor = (deal, brand) => {
  const urls = [`${BACKEND_URL}/api/catalogs/${deal.id}`];
  deal.images.forEach((src) => { urls.push(resolveUrl(src)); urls.push(thumbUrl(src)); });
  if (deal.pdf_url) urls.push(resolveUrl(deal.pdf_url));
  if (brand) {
    urls.push(`${BACKEND_URL}/api/brands/${brand.id}`);
    if (brand.logo) urls.push(resolveUrl(brand.logo));
  }
  return urls;
};

export const precache = (urls, key) => new Promise((resolve) => {
  const sw = navigator.serviceWorker;
  if (!sw) return resolve(false);
  const timer = setTimeout(() => { sw.removeEventListener('message', onMsg); resolve(false); }, 25000);
  const onMsg = (e) => {
    if (e.data?.type === 'CACHED' && e.data.key === key) { clearTimeout(timer); sw.removeEventListener('message', onMsg); resolve(true); }
  };
  sw.addEventListener('message', onMsg);
  sw.ready.then((reg) => (reg.active || sw.controller)?.postMessage({ type: 'CACHE_URLS', urls, key })).catch(() => resolve(false));
});

export const useOnline = () => {
  const [online, setOnline] = useState(navigator.onLine);
  useEffect(() => {
    const up = () => setOnline(true);
    const down = () => setOnline(false);
    window.addEventListener('online', up);
    window.addEventListener('offline', down);
    return () => { window.removeEventListener('online', up); window.removeEventListener('offline', down); };
  }, []);
  return online;
};
